import React from "react";
import { useNavigate } from "react-router-dom";

const imagen = require.context("./../img", true);

function Header() {
    const navigate = useNavigate()

    const go = () => {
        navigate("/login")    
    }
    return(
        <div className="header">
            <img className="header__img" src={imagen('./photo.png')} alt="Profile" onClick={() => go()}/>
            <h2 className="header__title">Ing. Leonardo J. Koryl</h2>
        </div>
    )
}

export default Header